import { getViewportClassForInput, isRegisteredViewportType, } from './viewportTypeToViewportClass.js';
export default function viewportTypeUsesCustomRenderingPipeline(viewportType) {
    if (!isRegisteredViewportType(viewportType)) {
        return false;
    }
    return Boolean(getViewportClassForInput({ type: viewportType })
        .useCustomRenderingPipeline);
}
export function viewportUsesCustomRenderingPipeline(viewport) {
    return viewport.getUseCustomRenderingPipeline();
}
